import type { ProductData } from '@ori/analytics-data';
import type { Maybe, Product } from '@ori/graphql-schema';

import type { Product as ProductTypes, SignalsData, SuggestionsAndResults } from '~/models';

// Formats array of Products gathered from GQL into Analytics format.
export const formatProducts = (
  products: Array<Maybe<Product> | undefined>,
  categoryName?: Maybe<string>,
): ProductData[] =>
  products.map((product) => ({
    currency: product?.price?.currency ?? '',
    globalBrandName: product?.concept?.brand?.originalName ?? '',
    globalCategoryName: '',
    globalName: product?.concept?.originalName ?? '',
    itemCode: product?.productCode ?? '',
    localBrandName: product?.concept?.brand?.originalName ?? '',
    localCategoryName: categoryName ?? '',
    localName: product?.concept?.productName ?? '',
    media: product?.imageUrl ? [product.imageUrl] : [],
    price:
      product?.price?.price?.currentPrice == null || Number.isNaN(product.price.price.currentPrice)
        ? 0
        : Number(product.price.price.currentPrice),
  }));

// Formats a single product from the API into Analytics format.
export const formatProduct = ({
  ActualPriceUnformated,
  ConceptName,
  CurrencyCode,
  GtmBrand,
  GtmCategory,
  ProductCode,
  ProductImageUrl,
}: ProductTypes): ProductData => ({
  currency: CurrencyCode,
  globalBrandName: '',
  globalCategoryName: '',
  globalName: '',
  itemCode: ProductCode,
  localBrandName: GtmBrand,
  localCategoryName: GtmCategory,
  localName: ConceptName,
  media: [ProductImageUrl],
  price: ActualPriceUnformated,
});

// Creates an object with Fusion Analytics data.
export const getSignalsData = (
  searchResults: SuggestionsAndResults,
  position: number,
  timestamp: number,
): SignalsData => ({
  SignalsParameters: {
    DocumentId: new URL(
      searchResults.Products[position]?.ProductDetailUrl as string,
      window.location.origin,
    ).toString(),
    FilterQueries: [],
    Position: position + 1,
    Query: searchResults.Query,
    SearchTime: Math.round(performance.now() - timestamp),
    SessionId: searchResults.OnlineSessionId,
    TotalHits: searchResults.Products.length,
  },
  TimeStamp: new Date(),
  Type: 'click',
});
